import React, { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import Swal from "sweetalert2";
import {
  MutationWithArrayInput,
  graphqlQuery,
  generateAndExecuteMutation,
} from "../../../../data/Axios/DynamicService";
import { AccountsandFinanceurl } from "../../../../config";
import DynamicForm from "../../../../data/Axios/DynamicForm";
import { AllCurrency } from "../../../../data/Axios/queries"; // Replace with actual query for base currencies

const base_url = AccountsandFinanceurl.uri;

const CurrencyForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const [baseCurrencies, setBaseCurrencies] = useState([]);
  const [loading, setLoading] = useState(true);

  // ✅ Initial form values
  const initialValues = {
    id: props.data ? props.data.id : "",
    currencyCode: props.data ? props.data.currencyCode : "",
    currencyName: props.data ? props.data.currencyName : "",
    exchangeRate: props.data ? props.data.exchangeRate : "",
    baseCurrencyId: props.data ? props.data.baseCurrencyId : "",
  };

  // ✅ Fetch Base Currencies
  async function fetchBaseCurrencies() {
    try {
      const data = await graphqlQuery(AllCurrency, base_url);
      if (data) setBaseCurrencies(data);
    } catch (error) {
      console.error("Error fetching base currencies:", error);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchBaseCurrencies();
  }, []);

  // ✅ Options for Base Currency Dropdown
  const baseCurrencyOptions = baseCurrencies
    ? baseCurrencies.map((currency) => ({
        value: currency.id,
        label: currency.currencyName,
      }))
    : [];

  // ✅ Define ALL form fields (complete field objects)
  const fields = [
    {
      name: "currencyCode",
      label: "Currency Code",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "currencyName",
      label: "Currency Name",
      type: "text",
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "exchangeRate",
      label: "Exchange Rate",
      type: "number",
      gridColumn: "span 2",
      required: true,
    },
    {
      name: "baseCurrencyId",
      label: "Base Currency",
      type: "select",
      options: baseCurrencyOptions,
      gridColumn: "span 2",
      required: true,
    },
  ];

  // ✅ Steps contain ONLY field names (strings), not objects
  const steps = [
    {
      stepLabel: "Currency Information",
      stepDescription: "Enter the basic details for the currency.",
      icon: "payment",
      fields: ["currencyCode", "currencyName", "exchangeRate"], // ✅ Just names!
    },
    {
      stepLabel: "Base Currency Settings",
      stepDescription: "Select the base currency for exchange rate reference.",
      icon: "settings",
      fields: ["baseCurrencyId"], // ✅ Just names!
    },
  ];

  // ✅ Submit Handler
  const handleSubmit = async (values, { setSubmitting }) => {
  try {
    const mutationData = {
      currencyCode: values.currencyCode,
      currencyName: values.currencyName,
      exchangeRate: parseFloat(values.exchangeRate),
      baseCurrencyId: values.baseCurrencyId,
      createdBy: userId,
    };

    if (props.isEditing) {
      mutationData.id = values.id;
      mutationData.updatedBy = userId;
    }

    const response = await generateAndExecuteMutation(
      props.isEditing ? "updateCurrency" : "createCurrency",
      mutationData,
      props.isEditing ? "updatedCurrency" : "newCurrency",
      base_url
    );

    if (Object.values(response)[0] != null) {
                 props.onClose();
                 props.onAction();
                 Swal.fire({
                   icon: "success",
                   title: "Success!",
                   text: `Tax rate ${
                     props.isEditing ? "updated" : "created"
                   } successfully.`,
                 });
               }
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "An error occurred while processing your request. Please try again later.",
          });
        }
    
        setSubmitting(false);
      };
  // ✅ Show Loader While Fetching
  if (loading) {
    return (
      <div className="flex justify-center items-center p-6">
        <CircularProgress />
      </div>
    );
  }

  // ✅ Render DynamicForm with correct structure
  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}  // ✅ Array of complete field objects
      steps={steps}    // ✅ Array with field names only
      onSubmit={handleSubmit}
      title={props.isEditing ? "Update Currency" : "Create Currency"}
      subtitle={
        props.isEditing
          ? "Update an existing currency record."
          : "Fill out the form below to create a new currency."
      }
    />
  );
};

export default CurrencyForm;